import React from 'react'

import { Icon, IconTypes, useFormatMessage } from '@acre/design-system'
import { useFlag } from '@acre/utils'

import type { FooterVariant } from './Footer.types'
import { GreyText, StyledDiv, StyledIcon } from './Footer.styles'

type FooterProps = {
  variant?: FooterVariant
}

const Footer = ({ variant = 'default' }: FooterProps) => {
  const formatMessage = useFormatMessage()
  const isScoreRebrand = useFlag('feature.score_rebrand_cp', false)

  const acreIcon = variant === 'light' ? IconTypes.AcreWordMarkLight : IconTypes.AcreWordMark
  const iconName = isScoreRebrand ? IconTypes.ScoreWordMarkGrey : acreIcon

  return (
    <StyledDiv>
      <GreyText variant={variant}>{formatMessage('dashboard.footer')}</GreyText>
      <StyledIcon sx={isScoreRebrand ? { svg: { height: 20, width: 'auto' } } : undefined}>
        <Icon name={iconName} />
      </StyledIcon>
    </StyledDiv>
  )
}

export default Footer
